const documentTypeImageTypeDict = state => state.documentTypeImageTypeDict
const getImageTypeByDocumentTypeId = state => documentTypeId => {
  return state.documentTypeImageTypeDict[documentTypeId]
}

export default {
  documentTypeImageTypeDict,
  getImageTypeByDocumentTypeId,
}
